import { ColumnReference, EffectiveDefinition, Schema } from '../../models/EffectiveDefinition';
import { ConstantType } from '../../transforms/calculations/ConstantCalculation';

export interface ThresholdFeature {
  thresholds: ThresholdSpec[];
}

export interface ThresholdSpec {
  lines: ThresholdLine[];
}

export interface ThresholdLine {
  measure: ColumnReference;
  timestamp?: ColumnReference;
  style?: ThresholdLineStyle;
}

export enum LineStyle {
  SOLID = 'solid',
  DASHED = 'dashed',
}

export enum DeltaLabelStyle {
  TARGET_VALUE = 'target-value',
  HISTORICAL_DELTA = 'historical-delta',
}

export enum LineLabelStyle {
  LATEST_VALUE = 'latest-value',
  NONE = 'none',
}

export interface ThresholdLineStyle {
  hidden: boolean;
  interactive: boolean;
  lineStyle: LineStyle;
  deltaLabel: DeltaLabelStyle;
  lineLabel: LineLabelStyle;
}

export const definitionWithStaticTarget = (definition: EffectiveDefinition, value: number): EffectiveDefinition => {
  const columnName = `static_threshold_${value}`;
  const newFeatures = {
    ...definition.features,
    threshold: {
      thresholds: [
        {
          lines: [
            {
              measure: { column: columnName },
              style: {
                hidden: false,
                interactive: false,
                deltaLabel: DeltaLabelStyle.TARGET_VALUE,
                lineStyle: LineStyle.DASHED,
                lineLabel: LineLabelStyle.LATEST_VALUE,
              },
            },
          ],
        },
      ],
    },
  };
  const newSchema: Schema = {
    ...definition.schema,
    [columnName]: {
      type: 'number',
      name: columnName,
      calculation: {
        type: ConstantType,
        value,
      },
    },
  };
  return { ...definition, features: newFeatures, schema: newSchema };
};
